
      // Marks the link to the page on screen. Client-side because one LiveView serves every SPA
      // page. The SPA changes the page without a new mount or update, so it announces each change
      // with `spa-navigated` (tester-work's `app/gt_frame.ts`).
      export default {
        mounted() {
          this.onSpaNavigated = () => this.mark()
          window.addEventListener("spa-navigated", this.onSpaNavigated)
          this.mark()
        },
        updated() { this.mark() },
        destroyed() { window.removeEventListener("spa-navigated", this.onSpaNavigated) },
        mark() {
          const path = window.location.pathname
          for (const link of this.el.querySelectorAll("a[href^='/']")) {
            const href = link.getAttribute("href")
            const current = path === href || path.startsWith(`${href}/`)
            current ? link.setAttribute("aria-current", "page") : link.removeAttribute("aria-current")
          }
        }
      }
    